import { PropsWithChildren, useState } from 'react';
import { ApiEndpoints } from '../../../../constants/endpoints/apiEndpoints.ts';
import useHookHub from '../../../../util/hubs/useHookHub';
import { ActivityOpenNotificationContext } from './ActivityOpenNotificationContext';

type ActivityOpenNotificationServerRpc = {
  OnCloseActivity: (activityId: number) => void;
  OnOpenActivity: (activityId: number) => string | undefined;
};

export default function ActivityOpenNotificationProvider(props: PropsWithChildren) {
  const [openBy, setOpenBy] = useState<string | undefined>(undefined);

  const [invoke] = useHookHub<ActivityOpenNotificationServerRpc>(ApiEndpoints.hubs.activityNotificationHub, {});

  const onOpenActivity = (activityId: number) => {
    if (invoke) {
      invoke('OnOpenActivity', activityId).then((val) => {
        setOpenBy(val);
      });
    }
  };

  const onCloseActivity = async (activityId: number) => {
    if (invoke) {
      await invoke('OnCloseActivity', activityId);
    }
  };
  return (
    <ActivityOpenNotificationContext.Provider value={{ onOpenActivity, onCloseActivity, openBy }}>
      {props.children}
    </ActivityOpenNotificationContext.Provider>
  );
}
